import React from "react";
import { gallery } from "../mock";

const Gallery = () => {
  return (
    <section id="clinica" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto reveal">
          <span className="text-xs font-semibold tracking-widest uppercase text-[#b89a5a]">
            Nossa Clínica
          </span>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-[#2f3a45] mt-4">
            Estrutura moderna e acolhedora
          </h2>
          <p className="text-[#4a5a68] mt-4">
            Um ambiente pensado para o seu conforto, com equipamentos de última geração.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5 mt-14">
          {gallery.map((src, i) => (
            <div
              key={i}
              className={`reveal group relative overflow-hidden rounded-2xl ${
                i === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <img
                src={src}
                alt={`Ambiente da clínica ${i + 1}`}
                className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${
                  i === 0 ? "h-64 md:h-full" : "h-48 md:h-56"
                }`}
              />
              <div className="absolute inset-0 bg-[#2f3a45]/0 group-hover:bg-[#2f3a45]/20 transition-all" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
